// extracted by mini-css-extract-plugin
export default {"container":"ColorectalCancerScreening_container__Gsuip","back-btn":"ColorectalCancerScreening_back-btn__hhe7j","back-icon":"ColorectalCancerScreening_back-icon__IZ029"};